import * as KeyCodes from './keycodes';
import { PluginEvent, PluginDomEvent, PluginEventType } from 'roosterjs-editor-types';

export default function smartSuggestionsPluginTrigger(evt: PluginEvent) {
    if (evt.eventType === PluginEventType.KeyUp) {
        const keyboardEvt: KeyboardEvent = (evt as PluginDomEvent).rawEvent as KeyboardEvent;
        if (keyboardEvt.which === KeyCodes.ENTER || keyboardEvt.which === KeyCodes.SPACE) {
            return true;
        }
    }

    return false;
}
